import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SparklesIcon } from '@heroicons/react/24/outline';

const ThankYou = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-800 mb-4 mt-8 flex flex-row items-center justify-center">
            Thank You! <SparklesIcon className="text-yellow-500 w-16 h-16 mb-6 items-center justify-center mx-1" />
          </h1>
          <p className="text-gray-600 mb-8">
            Your message has been sent successfully. We'll get back to you soon.
          </p>
          <Link
            to="/"
            className="bg-[#1a365d] text-white px-6 py-3 rounded-lg hover:bg-[#122743] transition-colors duration-300"
          >
            Return to Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;